import { render, staticRenderFns } from "./formManufacturer.vue?vue&type=template&id=b36c4e9a&scoped=true&"
import script from "./formManufacturer.vue?vue&type=script&lang=js&"
export * from "./formManufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36c4e9a",
  null
  
)

export default component.exports